import React from 'react'
import TableViewIcon from '@mui/icons-material/TableView';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

export const menuItemsAdmission = [
    {
        text: 'Dashboard',
        icon: <DashboardIcon />,
        path: '/admin/DashBoardUpdates',
    },
    {
        text: 'Admission',
        icon: <TableViewIcon />,
        path: '',

        submenu: [
            {
                text: 'View Form',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/AdmissionData',
            },
        ]
    },
]
